"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuLinkOption = void 0;
const KHMenuOption_1 = require("./KHMenuOption");
class KHMenuLinkOption extends KHMenuOption_1.KHMenuOption {
    constructor(text, url, description, selectable = true, extras = {}) {
        super(text, description, selectable, () => {
            window.open(url, "_blank");
        }, null, extras);
    }
}
exports.KHMenuLinkOption = KHMenuLinkOption;
